export default "__VITE_ASSET__BPLLnvio__"